/**
 * @generated SignedSource<<f8d43422d2995aa82923e92f94405c6d>>
 * @relayHash 841acdcd6c7c52f26b5f3e3d7cb53c5f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2bee1c43ff9a3e78ca2692ac116b94d163df574ed7ce237a88b6791f6e6581b4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2bee1c43ff9a3e78ca2692ac116b94d163df574ed7ce237a88b6791f6e6581b4",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
